<div class="page-contents">
    <div class="subBlockContainer">
        <div class="breadcrumbWrapper">
            <app-breadcrumb (notify)='onClicked($event)'></app-breadcrumb>
        </div>
        <div class="blockContainer narrow-sidebar subBlockContainer_toplevel" id='levelOne' [class.xscroll]="showXscroll" [class.hidex]="lastChild!='finance'&&lastChild!='financeDetails'&&lastChild!='enduser'&&lastChild!='me'&&lastChild!='borrowedetails'&&lastChild!='financesummary'">
            <!-- <div class="combination-loader" [class.extendwidth]="lastChild=='finance'||lastChild=='financeDetails'||lastChild=='enduser'||lastChild=='me'||lastChild=='borrowedetails'||lastChild=='financesummary'"> -->
            <div class="combination-loader extendwidth combinedLoader" [class.product]="viewProduct">
                <!-- Showing cart names -->
                <div class="child-sidebar" *ngIf="!checkoutInitiated">
                    <child-header [title]="title"  (closeEvent)="navigateTo('/home')" (addEvent)="openModal(changeCartNameContainer)" titleAdd="Create New Cart" [showAdd]="true" ></child-header>
                    <div class="page-title-wrapper" style="display: none;">
                        <div class="title blade-title">
                            {{title}}
                        </div>

                        <ng-container *ngIf="currentUserModel?.source!='SAP'">

                                <div class="basic-icon add-icon add-icon-position" (click)="open(changeCartNameContainer, $event)" title="Add Shopping Cart"><mat-spinner *ngIf="!loadShoppingCart" mode="indeterminate" class="circle cart-loading-icon" diameter="20"> </mat-spinner> </div>

                        </ng-container>

                        <i class="material-icons closebutton-pullfloat-right" [routerLink]="['/home']">close</i>
                    </div>
                    <div class="child-body">
                    <loading-screen *ngIf="!loadContent" [isScrolled]="true" [showBlurTable]="false" backDropWidth="250" (currentLoadingStatus)="onLoading($event)"></loading-screen>
                        <div id="filterGroup" class="menu-wrapper menu-wrapper-small filter-padding">
                            <div class="searchInputGroup">
                                <div class="searchIcon search-carts">
                                    <img src="../images/new_ui/filter.png">
                                </div>
                                <input #searchInput class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''" onblur="this.placeholder='Filter'" [(ngModel)]="searchText" (ngModelChange)="filterShoppingCarts()">
                                <!-- <div class="btnAddBlade" (click)="open(changeCartNameContainer, $event)" title="Add Shopping Cart">
                    <img src="/images/new_ui/addIcon.png">
                </div> -->
                                <!-- <div class="basic-icon add-icon" style="width: 25px; height: 25px;" (click)="open(changeCartNameContainer, $event)" title="Add Shopping Cart"></div> -->
                            </div>
                        </div>

                        <ng-container *ngIf="currentUserModel?.source!='SAP'">

                            <div class="menu-wrapper menu-wrapper-cart watch-list-container" (click)="accessWatchList()">
                                <div class="total-div">
                                    <div class="cartname-edit">Watch List</div>
                                    <span class="cart-quantity" style="font-size: 9px !important;">Items: {{watchListItems?.length?watchListItems?.length:0}}</span>
                                </div>
                            </div>

                        </ng-container>


                        <ng-container *ngIf="shoppingCarts">
                            <ng-container *ngFor="let item of shoppingCartsFilter">
                                <div class="menu-wrapper menu-wrapper-small" (click)="setActiveCart(item)" [class.active]="selectedCartId == item.cartId && !watchListView" [routerLink]="'cart/' + item.cartId+'/'+item.encodedCartName" >
                                    <div class="total-div">
                                        <div class="narrow-title">{{item?.cartName}}</div>
                                        <span class="narrow-text">Items: {{item?.totalQuantity}} |</span>
                                        <span class="narrow-text">Total:
                        {{item?.totalPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                                    </div>
                                    <ng-container *ngIf="item.status && item.status == 3">
                                        <div class="global-icon-wrapper">
                                            <!-- <img src="/images/new_ui/globalShoppingCartActive.png"> -->
                                            <span class="share-button"></span>
                                        </div>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </ng-container>

                        <div *ngIf="shoppingCartsFilter && shoppingCartsFilter.length < 8">
                            <vertical-banner [bannerLocation]="'cart'"></vertical-banner>
                        </div>
                    </div>
                </div>
                <!-- Showing check out process -->
                <div class="child-sidebar" *ngIf="checkoutInitiated">
                    <child-header title="Checkout" (closeEvent)="closeCheckoutPanel()"></child-header>
                    <!-- <div class="scroll-wrapper sidebar-loader"> -->
                    <!-- <div class="page-title-wrapper">
                        <div class="title blade-title">
                            Checkout
                        </div>
                        <i class="material-icons closebutton-pullfloat-right" (click)="closeCheckoutPanel()">close</i>
                    </div> -->
                    <!-- <ul class="cart-list-group cart-list-group-flush">
            <li *ngFor="let item of checkoutMenuFilter" class="cart-list-group-item" (click)="redirectTo(item.stepName);"
              [class.currentStep]="item.stepName == currentCheckoutStep" style="padding-top: 14px;" [id]="item.id">
              <span>{{item.menuName}}</span>
              <span [hidden]="item.stepName == currentCheckoutStep" class="check-wrapper">
                </span>
            </li>
          </ul> -->
                    <div class="child-body checkoutMenu">
                        <ng-container *ngFor="let item of checkoutMenuFilter">
                            <div [id]="item.id" class="menu-wrapper cart-list-group-item" [class.currentStep]="item.stepName == currentCheckoutStep" [class.active]="item.stepName == currentCheckoutStep" (click)="redirectTo(item.stepName);">

                                <label class="small-title">{{item.menuName}}</label>
                                <span [hidden]="item.stepName == currentCheckoutStep" class="check-wrapper"></span>
                            </div>
                        </ng-container>
                    </div>

                </div>

                <div class="child-loader">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </div>
    <!-- Popup for Add Cart Modal -->
    <ng-template #changeCartNameContainer let-c="close" let-d="dismiss">
        <div class="shopping-cart-modal shopping-cart-size">
      <child-header title="Cart Name" (closeEvent)="d('Cross click')"></child-header>
            <div class="modal-body">
                <input class="cart-name-modal pop-up-black-text col-md-12" #editCartShopCartName type="text" (keyup.enter)="addNewCartWithNewName(editCartShopCartName.value); d('Cross click')">

                <div class="save-button-position">
                    <section>
                        <button type="button" class="button button-red button-large" (click)="addNewCartWithNewName(editCartShopCartName.value)" (click)="d('Cross click')">Add cart</button>
                    </section>
                </div>

            </div>
        </div>
    </ng-template>
</div>
